<div class="header-wrapper"
    (click)="toggleDrawer()">
    <div class="header-wrapper"
         data-automation-e2e-selector="marketDrawerHeader"
         *ngIf="(live | async) && (dealDateDefined | async)">
        <muni-gameday-market-drawer-markets-header data-automation-e2e-selector="marketsHeader">
        </muni-gameday-market-drawer-markets-header>
        <muni-gameday-market-drawer-ust-header data-automation-e2e-selector="ustHeader">
        </muni-gameday-market-drawer-ust-header>
        <muni-gameday-market-drawer-mmd-header data-automation-e2e-selector="mmdHeader">
        </muni-gameday-market-drawer-mmd-header>
        <muni-gameday-market-drawer-calendar-header [style.width]="40 + '%'" data-automation-e2e-selector="calendarHeader">
        </muni-gameday-market-drawer-calendar-header>
    </div>
    <div class="header-wrapper"
         *ngIf="!(live | async) && (dealDateDefined | async)">
        <h3 data-automation-e2e-selector="historicalMarketDrawerHeader">Market details for {{(date | async).format('dddd, MMMM Do, YYYY')}}</h3>
    </div>
    <div class="header-wrapper"
         *ngIf="!(dealDateDefined | async)">
        <h3>Loading...</h3>
    </div>
    <div class="arrow"
         data-automation-e2e-selector="arrow"
         [ngClass]="{'expanded': open | async}">
    </div>
</div>